export default __webpack_public_path__ + "2cd8389e72f6db599c68dee3a4526807.jpg";